import React from "react";
import { Link } from "react-router-dom";
import GMap from "./GMap";
import Logo from "../Logo/Logo";

const Footer = () => {
  return (
    <>
      {/* <CallToAction /> */}
      <footer className="footer pb-5 pt-10 bg-light position-relative mt-8 ">
        <div className="position-absolute w-100 z-index-1 top-0 mt-n3">
          <svg
            width="100%"
            viewBox="0 -2 1920 157"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
          >
            <title>wave-down</title>
            <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
              <g fill="#FFFFFF" fillRule="nonzero">
                <g id="wave-down">
                  <path
                    d="M0,60.8320331 C299.333333,115.127115 618.333333,111.165365 959,47.8320321 C1299.66667,-15.5013009 1620.66667,-15.2062179 1920,47.8320331 L1920,156.389409 L0,156.389409 L0,60.8320331 Z"
                    id="Path-Copy-2"
                    transform="translate(960.000000, 78.416017) rotate(180.000000) translate(-960.000000, -78.416017) "
                  />
                </g>
              </g>
            </g>
          </svg>
        </div>
        <div className="container">
          <div className="row">
            {/* Logo and Links */}
            <div className="col-lg-3">
              {/* <h6 className="font-weight-bolder mb-lg-4 mb-3">Omnia Steels</h6> */}
              <Logo className="footer-logo" isDark={true} />
            </div>
            <div className="col-lg-6 text-center">
              <ul className="nav flex-row align-items-center mb-5 mt-sm-0 justify-content-center">
                <li className="nav-item">
                  <Link className="nav-link" to="/">
                    Home
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/about">
                    About Us
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/careers">
                    Careers
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/contact-us">
                    Contact Us
                  </Link>
                </li>
              </ul>
              <p className="mb-0 d-none d-lg-block">
                Copyright © Omnia Steels Private Limited.
              </p>
            </div>

            {/* Contact Info */}
            <div className="col-lg-3">
              <h6 className="font-weight-bolder mb-3">corporate address</h6>
              <div className="d-flex flex-row align-items-center mb-3">
                <Link
                  to="https://wa.me/9676270055"
                  target="_blank"
                  className="footer-social-icon"
                >
                  <img
                    src="/images/Footer/phone.svg"
                    style={{
                      width: "20px",
                    }}
                  />
                </Link>
                <Link
                  to="mailto:salesteam@omniasteels.com"
                  target="_blank"
                  className="footer-social-icon"
                >
                  <img src="/images/Footer/email.svg" />
                </Link>
                <Link
                  to="https://in.linkedin.com/company/omniasteels"
                  target="_blank"
                  className="footer-social-icon"
                >
                  <img
                    src="/images/Footer/linked.svg"
                    style={{
                      width: "18px",
                    }}
                  />
                </Link>

                {/* <Link to="https://wa.me/9676270055" target="_blank">
                <p className="mb-0">
                  <i className="fas fa-phone" /> +91 9676270055
                </p>
              </Link>
              <Link to="mailto:salesteam@omniasteels.com" target="_blank">
                <p className="mb-0">
                  <i className="fas fa-envelope" /> salesteam@omniasteels.com
                </p>
              </Link>
              <Link
                to="https://in.linkedin.com/company/omniasteels"
                target="_blank"
              >
                <p className="mb-0">
                  <i className="fa fa-linkedin" /> Omnia Steels Private Limited
                  | LinkedIn
                </p>
              </Link> */}
              </div>
              <Link
                to="https://maps.app.goo.gl/NpaMyPSH8DCzzBDp8"
                target="_blank"
              >
                <p className="mb-0">
                  <i className="fas fa-home" /> 2nd Floor G&G Business Centre,
                  Kanta Reddy Nagar, Pillar number 125, Attapur, Hyderabad
                  Telangana - 500048
                </p>
              </Link>
            </div>
          </div>
          <p className="mt-1 d-lg-none">
            Copyright © Omnia Steels Private Limited.
          </p>
        </div>
      </footer>
      {/* END FOOTER */}
    </>
  );
};

export default Footer;
